<template>
  <footer class="main-footer">
    <strong>Copyright &copy; {{year}}
      <a href="http://www.solidtectecnologia.com.br">Solidtec Tecnologia</a></strong>
  </footer>
</template>

<script>
export default {
  name: 'DashFooter',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashFooter.vue?69d7b710